import styles from '@ui/components/Heading/Heading.module.scss';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Heading = forwardRef(
  (
    {
      align = null,
      as = null,
      children = null,
      className = null,
      noSpacing = false,
      notResponsive = false,
      size = 'h1',
      theme = 'default',
      withParser = false,
      ...props
    },
    ref,
  ) => {
    const Tag = as || size;

    return (
      <Tag
        className={classNames(
          styles.container,
          className,
          styles[size],
          styles[theme],
          {
            [styles[align]]: align,
            [styles.noSpacing]: noSpacing,
            [styles.notResponsive]: notResponsive,
          },
        )}
        dangerouslySetInnerHTML={
          withParser ? { __html: withParser && children } : null
        }
        ref={ref}
        {...props}
      >
        {!withParser ? children : null}
      </Tag>
    );
  },
);

Heading.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  as: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.elementType,
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  noSpacing: PropTypes.bool,
  notResponsive: PropTypes.bool,
  size: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7']),
  theme: PropTypes.oneOf(['default', 'neutral', 'contrast']),
  withParser: PropTypes.bool,
};

Heading.displayName = 'Heading';

export default Heading;
